<template>
    <div>
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">Log Report</li>
		</ol>

        <h1 class="page-header">Log Report</h1>
        <hr>

         <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="row ">
                <div class="col-lg-4 col-xs-12 " style="padding-left:0" >
                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-3 col-form-label">Status</label>
                        <div class="col-sm-9">
                            <select class="form-control" style="width:100%" v-model="filter.status">
                                <option value="" selected>All Status</option>
                                <option value="Success">Success</option>
                                <option value="Failed">Failed</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-3 col-form-label col-xs-12"  style="padding-left:0">Date</label>
                        
                        <div class="input-group-append col-sm-9 col-xs-12 pl-0">
                            <date-range-picker id="dateTimeInput" v-model="dateRange" style="width:100%" >
                                <div slot="input" class="text-center" slot-scope="picker" opens="right" >
                                    <i class="fa fa-calendar fa-fw text-white-transparent-5 ml-n1"></i> 
                                    {{ moment(dateRange.startDate).format("DD MMMM YYYY")}} - {{ moment(dateRange.endDate).format("DD MMMM YYYY")}}
                                    <b class="caret"></b>
                                    
                                </div>
                            </date-range-picker>
                            <label for="dateTimeInput" class="input-group-text">
                                <i class="fa fa-calendar"></i>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-md-8 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-3 col-form-label col-xs-12"  style="padding-left:0">Start</label>
                        <div class="input-group-append col-sm-9 col-xs-12 pl-0">
                            <vue-timepicker format="HH:mm" input-class="form-control h-100" input-width="100%" v-model="filter.start_hour" placeholder="Time Start (Default 00:00)"></vue-timepicker>
                        </div>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-2 col-md-8 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-3 col-form-label col-xs-12"  style="padding-left:0">End</label>
                        <div class="input-group-append col-sm-9 col-xs-12 pl-0">
                            <vue-timepicker format="HH:mm" input-class="form-control h-100" input-width="100%"  v-model="filter.end_hour" placeholder="Time End (Default 23:59)"></vue-timepicker>
                        </div>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-2 offset-lg-2 col-xs-12">
                    <input type="button" class="btn btn-primary float-right" style="width:100%" @click="search()" value="Search"></input>
                </div>
            </div>
        </panel>
        

        <!--Line Chart-->
        <successVsfailChart class="mt-3" v-if="filterReady"></successVsfailChart>


        <!---Table Report Log Start-->
        <reportLogTable class="mt-4" v-if="filterReady"></reportLogTable>
    </div> 
</template>

<script>
    import DateRangePicker from "vue2-daterange-picker";
    
    import moment from 'moment';
    import * as am4core from "@amcharts/amcharts4/core";
    import VueTimepicker from 'vue2-timepicker/dist/VueTimepicker.umd.min.js'

    // import child components
    import reportLogTable from './childComponents/reportLogTable'
    import successVsfailChart from './childComponents/charts/successVsFail';
    
    export default{
        data(){
            var startDate = moment().startOf('month')._d;
            var compareDate = {
                startDate :  new moment().subtract(1, 'months').date(1),
                endDate : new moment().date(0)
            }

            var filter = {
                start_date  : moment(startDate).format('YYYY-MM-DD'),
                end_date : new moment().format('YYYY-MM-DD'),
                status : "",
                start_hour : '00:00',
                end_hour : '23:59'
            }

            return{
                moment : moment,
                dateRange: {
                    startDate : startDate,
                    endDate : new moment()._d
                },
                format: moment.localeData().longDateFormat('L'),
                filter : filter,
                filterReady : false,
                searchButton : false
            }
        },
        components : {
            DateRangePicker,
            successVsfailChart,
            reportLogTable,
            VueTimepicker
        },
        beforeDestroy(){
            am4core.disposeAllCharts();
            
            this.$store.state.filterUrl = '';
        },
        watch : {
            dateRange : function(){
                let start_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                let end_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');
                this.filter.start_date = start_date;
                this.filter.end_date = end_date;
            },
        },
        mounted(){
            this.initialiseFilter();
        },
        methods : {
            initialiseFilter(){
                var keys = Object.keys(this.filter);
                let stringUrl = '?';
                var queryParams = this.filter;

                for(var i = 0 ; i < keys.length; i++){
                    if(keys[i] == 'status' && queryParams[keys[i]] == '')
                        continue;
                    
                    stringUrl += `${keys[i]}=${queryParams[keys[i]]}&`;
                    
                }
                this.$store.state.filterUrl = stringUrl;
                this.filterReady = true;
            },
            async search(){
                if(this.searchButton)
                    return;
                
                await this.initialiseFilter();

                this.searchButton = true;
                this.$store.state.updateData++;
                console.log(this.$store.state.updateData);
                this.searchButton = false;
            }
        }
    }
</script>

